import React from "react";
import { BsLinkedin } from "react-icons/bs";
import { Pagination } from "swiper";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "./testimonials.css";

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      link: "upwork.com",
      name: "Upwork Client",
      role: "Full-Stack Web Developer. JavaScript | Rails | React | Redux. Improving open-source projects, one commit at a time.",
      test: "Abdulah worked very hard to get the job done! He is definitely very knowledgeable about the job and very helpful. Even when the job turned out to be more difficult / time consuming than first expected, he kept going on and made it work very well! Would definitely recommend.",
    },
    {
      id: 2,
      name: "Upwork Client",
      role: "Client",
      test: "Abdulah is AMAZING! He took a broken mess from a previous developer (HTML, CSS, WordPress project) and worked his magic to transform it into something worth being proud of! If you need a competent, highly-skilled developer - do not hesitate to hire him immediately!! 5+++ star experience!",
    },
    {
      id: 3,
      link: "upwork.com",
      name: "Upwork Client",
      role: "Full-stack developer | Technical Support Engineer at Microverse",
      test: "Fast, easy to talk and very good developer. Hope to do more jobs with Abdulah!",
    },
    {
      id: 4,
      link: "upwork.com",
      name: "Upwork Client",
      role: "Full Stack Developer| Ruby on Rails | PostgreSQL | JavaScript | React | Redux | Html&Css | Python.",
      test: "It was a pleasure collaborating with Abdullah. His expertise in WordPress is exceptional, and I was particularly impressed by his proactive approach. Not only did he efficiently complete the assigned tasks, but he also went above and beyond by optimizing the website for both performance and speed. I look forward to working with him again in the future.",
    },

    {
      id: 6,
      link: "upwork.com",
      name: "Upwork Client",
      role: "Software Developer",
      test: "Throughout all our collaborations, Abdulah has always conducted herself politely and kindly. He comes across as someone that's always willing to help and puts the team ahead of himself. But beneath this, I see a strength and determination to distinguish himself. He's not only someone I highly recommend but is also someone I greatly respect.",
    },
  ];
  return (
    <section id="testmonials">
      <h5>Feedback from my peers</h5>
      <h2>Testimonials</h2>
      <Swiper
        className="container testimonials__container"
        modules={[Pagination]}
        spaceBetween={40}
        slidesPerView={1}
        pagination={{ clickable: true }}
      >
        {testimonials.map((test) => (
          <SwiperSlide className="testimonial" key={test.id}>
            <div className="client__avatar">
              {/* <a href={test.link}>
                <BsLinkedin />
              </a> */}
            </div>
            <h5 className="client__name">{test.name}</h5>
            <small className="client__review">{test.test}</small>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default Testimonials;
